import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getUpcomingEvent } from "../Redux/Actions/eventData";

export default function About() {
  const dispatch = useDispatch();

  const eventUpcoming = useSelector((e) => e.eventAuth.upcomingEvent);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch(getUpcomingEvent());
  }, [dispatch]);

  const handleInstagramClick = () => {
    window.open(
      'https://www.instagram.com/biancablezardviolin/?fbclid=IwY2xjawJjMOZleHRuA2FlbQIxMAABHq_5-R0uCGho5qiI_L__mar_TI0knCvPZ06Wl5rndYkopw8qlELyZNiBwR_F_aem_LyJ9zBw2I-_XAfIHU0qHCw#',
      '_blank'
    );
  };

  const handleTikTokClick = () => {
    window.open(
      'https://www.tiktok.com/@biancablezardviolin?_t=8ivCYtkWnOC&_r=1',
      '_blank'
    );
  };


  const handleInstagramClickEstere = () => {
    window.open(
      'https://www.instagram.com/estere.eversone.violin?igsh=MTAzZXQ5eWdjOXl4dQ==',
      '_blank'
    );
  };


  return (
    <Layout className="main-wrap">
      <Container fluid className="mt-4 p-0 custom-boxx">
        <Row>
          <Col lg={12}>
            <div className="about-box-sec">
              <div className="about-box-title">
                <p>Meet Your Musician</p>
                <h2>Discover the passion and talent behind your big day.</h2>
              </div>
              {eventUpcoming?.musician?.fullName
                ?.trim()
                ?.startsWith("Bianca") && (
                  <Row className="about-sec-set">

                    <Col lg={8} className="mt-4 mt-lg-0">
                      <div className="about-txt-side">
                        <h3>Bianca Blezard </h3>
                        <p>
                          Bianca is a classically-trained professional violinist
                          with over fifteen years’ experience in the wedding
                          industry. Having graduated from the Royal Northern
                          College of Music, she spent over a decade working for
                          agencies providing music in some of the most high-end
                          and exclusive venues in the UK. In 2022 when she
                          discovered how much these agencies were charging their
                          clients on top of the musicians’ fees, she used her
                          wealth of experience and knowledge to branch out into
                          her own business, providing couples all over the world
                          with an unparalleled standard of performance at a much
                          more affordable price. She is deeply passionate about
                          her role as a wedding violinist, understanding fully the
                          gravity of her role and the impact it has on the entire
                          celebration. Her job is not just to provide a flawless
                          performance, but also to create the emotional journey of
                          your day through the careful curation of her tracks.
                        </p>
                        <p>
                          Outside of her wedding performances, Bianca has a wealth
                          of experience in all areas of the music industry. She
                          has performed with celebrities such as Robbie Williams,
                          Rod Stewart, and Sting, and played on the UK tours of
                          West End shows The Lion King and Les Miserables. She has
                          written music for and performed with metal bands
                          Winterfylleth and Atavist, and is the lead violinist of
                          The ELO Show, the UK’s best tribute band to Jeff Lynne’s
                          Electric Light Orchestra. She also led the Gatecrasher
                          Orchestra, and performs regularly with Symphonic Ibiza,
                          as well as at restaurants, clubs, corporate events, and
                          private parties.
                        </p>
                        <ul className="social-list">
                          <li className="social-item">
                            <img onClick={handleInstagramClick}
                              style={{ cursor: 'pointer' }} src={require("../Assets/Images/insta.png")} alt="" />
                            <a
                              href="https://www.instagram.com/biancablezardviolin/?fbclid=IwY2xjawJjMOZleHRuA2FlbQIxMAABHq_5-R0uCGho5qiI_L__mar_TI0knCvPZ06Wl5rndYkopw8qlELyZNiBwR_F_aem_LyJ9zBw2I-_XAfIHU0qHCw#"
                              style={{ display: 'none' }}
                            ></a>
                          </li>

                          <li className="social-item">
                            <img onClick={handleTikTokClick}
                              style={{ cursor: 'pointer' }} src={require("../Assets/Images/tik-tok.png")} alt="" />
                            <a
                              href="https://www.tiktok.com/@biancablezardviolin?_t=8ivCYtkWnOC&_r=1"
                              style={{ display: 'none' }}
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="about-img-sid">
                        {/* <div class="blur-overlay"></div> */}
                        <img src={require("../Assets/Images/biancaimg.jpg")} />
                      </div>
                    </Col>
                  </Row>
                )}

              {eventUpcoming?.musician?.fullName
                ?.trim()
                ?.startsWith("Estere") && (
                  <Row className="about-tow-sec-set">
                    <Col lg={4}>
                      <div className="about-img-sid">
                        {/* <div class="blur-overlay"></div> */}
                        <img src={require("../Assets/Images/estereimg.jpg")} />
                      </div>
                    </Col>

                    <Col lg={8}>
                      <div className="about-txt-side">
                        <h3>Estere Eversone </h3>
                        <p>
                          Estere is a classically-trained professional violinist,
                          originally from Latvia. She studied at the Ernesta
                          Vῑgnera Kuldῑgas Music School before moving to the UK,
                          and has been performing here since 2022. In 2023 she
                          became the trusted second violinist for Bianca Blezard
                          Violin, and has since been proudly performing at
                          weddings all around the UK on her behalf. They have been
                          working as a team to produce an unparalleled standard of
                          performance and customer service, creating music and
                          bespoke tracks that are exclusive to them. Estere is
                          deeply passionate about her role as a wedding violinist,
                          understanding fully the gravity of her role and the
                          impact it has on the entire celebration, and she works
                          continuously to bring a beautiful tone and sensitive
                          performance to every event.
                        </p>
                        <p>
                          Outside of her wedding specialism, Estere performs
                          around the UK in The ELO Show, the UK’s leading tribute
                          band to The Electric Light Orchestra, and regularly
                          appears as part of Symphonic Ibiza and Manchester
                          Camerata’s Hacienda Classical. She also performs in
                          Musical Theatre productions around Yorkshire, as well as
                          at corporate events and private parties.
                        </p>
                        <ul className="social-list">
                          <li className="social-item">

                            <img onClick={handleInstagramClickEstere}
                              style={{ cursor: 'pointer' }} src={require("../Assets/Images/insta.png")} alt="" />
                            <a
                              href="https://www.instagram.com/estere.eversone.violin?igsh=MTAzZXQ5eWdjOXl4dQ=="
                              style={{ display: 'none' }}
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                )}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="pb-4">
        <p className="mb-0"></p>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Request a change</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Lorem ipsum dolor sit"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleClose}>
            Request
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
